import { render, staticRenderFns } from "./HistoryPersonTimeline.vue?vue&type=template&id=6872cbdb&scoped=true&"
import script from "./HistoryPersonTimeline.vue?vue&type=script&lang=js&"
export * from "./HistoryPersonTimeline.vue?vue&type=script&lang=js&"
import style0 from "./HistoryPersonTimeline.vue?vue&type=style&index=0&id=6872cbdb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6872cbdb",
  null
  
)

export default component.exports